import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6">
          {/* Logo & Info Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-2">
              <h1 className="text-2xl font-bold text-white">Greenfield Partners</h1>
              <p className="text-sm text-slate-400 mt-1">Precision Drone Services</p>
            </Link>
            <p className="text-sm text-slate-400 mb-4 mt-4">
              Professional drone spraying services for agriculture, forestry, and land management across the Mid-Atlantic.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Services</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/services" className="text-sm hover:text-emerald-400 transition-colors">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/services/agriculture" className="text-sm hover:text-emerald-400 transition-colors">
                  Agriculture
                </Link>
              </li>
              <li>
                <a href="/services/timber-forestry" className="hover:text-white transition-colors">
                  Timber & Forestry
                </a>
              </li>
              <li>
                <a href="/services/land-intelligence" className="hover:text-white transition-colors">
                  Land Intelligence
                </a>
              </li>
              <li>
                <a href="/services/portfolio-monitoring" className="hover:text-white transition-colors">
                  Portfolio Monitoring
                </a>
              </li>
              <li>
                <Link to="/services/deer-deterrent" className="text-sm hover:text-emerald-400 transition-colors">
                  Deer Deterrent
                </Link>
              </li>
              <li>
                <Link to="/services/deer-survey" className="text-sm hover:text-emerald-400 transition-colors">
                  Deer Survey
                </Link>
              </li>
              <li>
                <Link to="/services/recovery" className="text-sm hover:text-emerald-400 transition-colors">
                  Recovery Services
                </Link>
              </li>
              <li>
                <Link to="/infrastructure-pricing" className="text-sm hover:text-emerald-400 transition-colors">
                  Infrastructure Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Tools Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Tools</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/instant-quote" className="text-sm hover:text-emerald-400 transition-colors">
                  Instant Quote
                </Link>
              </li>
              <li>
                <Link to="/roi-calculator" className="text-sm hover:text-emerald-400 transition-colors">
                  ROI Calculator
                </Link>
              </li>
              <li>
                <Link to="/spray-window-advisor" className="text-sm hover:text-emerald-400 transition-colors">
                  Spray Window Advisor
                </Link>
              </li>
              <li>
                <Link to="/crop-calendar" className="text-sm hover:text-emerald-400 transition-colors">
                  Crop Calendar
                </Link>
              </li>
              <li>
                <Link to="/operator-checklist" className="text-sm hover:text-emerald-400 transition-colors">
                  Operator Checklist
                </Link>
              </li>
              <li>
                <Link to="/field-complexity" className="text-sm hover:text-emerald-400 transition-colors">
                  Field Complexity Estimator
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/case-studies" className="text-sm hover:text-emerald-400 transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/seasonal-programs" className="text-sm hover:text-emerald-400 transition-colors">
                  Seasonal Programs
                </Link>
              </li>
              <li>
                <Link to="/blog/drone-maps-precision-agriculture" className="text-sm hover:text-emerald-400 transition-colors">
                  Drone Mapping Guide
                </Link>
              </li>
              <li>
                <Link to="/drone-spraying-problems" className="text-sm hover:text-emerald-400 transition-colors">
                  When Spraying Goes Wrong
                </Link>
              </li>
              <li>
                <Link to="/blog/deer-damage-cost" className="text-sm hover:text-emerald-400 transition-colors">
                  Deer Damage Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm hover:text-emerald-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-sm hover:text-emerald-400 transition-colors">
                  Financing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-2.5 mb-6">
              <li>
                <Link to="/about" className="text-sm hover:text-emerald-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/how-we-work" className="text-sm hover:text-emerald-400 transition-colors">
                  How We Work
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-sm hover:text-emerald-400 transition-colors">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm hover:text-emerald-400 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-emerald-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-2">
              <li className="text-sm flex items-start gap-2">
                <i className="ri-phone-line text-emerald-400 mt-0.5"></i>
                <a href="tel:+15551234567" className="hover:text-emerald-400 transition-colors">
                  (555) 123-4567
                </a>
              </li>
              <li className="text-sm flex items-start gap-2">
                <i className="ri-mail-line text-emerald-400 mt-0.5"></i>
                <a href="mailto:info@greenfieldpartners.com" className="hover:text-emerald-400 transition-colors">
                  info@greenfieldpartners.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-400">
            © {currentYear} Greenfield Partners. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
              Terms of Service
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-slate-400 hover:text-emerald-400 transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
